module.exports = __webpack_public_path__ + "img/bg-program-consultation.4db853f0.png";